<template>
  <div id="us-footer">
      
     
      
        <div class="us-footer-content">
          
          
          <div class="us-footer-content-left">
            <div class="us-footer-address">
              <span style="font-size:25px;line-height:50px;"><b>LWW Bustouristik GmbH</b></span><br>
              <span>Am Herrnberg 6</span><br>
              <span>98724 Neuhaus am Rennweg</span><br>
              <span><b>Telefon:</b> +49 (0) 3679/7848-0</span><br>
              <span><b>Telefax:</b> +49 (0) 3679/7848-28</span><br>
              <span><b>E-Mail:</b> kundendienst@lww.de</span>
            </div>
          </div>
          <div class="us-footer-content-center">


                  <el-menu :router="true"> 
                    <el-menu-item index="/article/26" @click="$emit('getTopSliderTop')">
                      <fai :icon="['fal', 'users-medical' ]" style="font-size:20px;"></fai>
                      <span> Stellenangebote</span>
                    </el-menu-item>
                    <el-menu-item index="/article/28" @click="$emit('getTopSliderTop')">
                      <fai :icon="['fal', 'download' ]" style="font-size:20px;"></fai>
                      <span> Downloadbereich</span>
                    </el-menu-item>
                    <el-menu-item index="/article/72" @click="$emit('getTopSliderTop')">
                       <fai :icon="['fal', 'shield-check' ]" style="font-size:20px;"></fai>
                      <span> Datenschutz</span>
                    </el-menu-item>
                    <el-menu-item index="/article/3" @click="$emit('getTopSliderTop')">
                       <fai :icon="['fal', 'stamp' ]" style="font-size:20px;"></fai>
                      <span> Impressum</span>
                    </el-menu-item>
                    <el-menu-item index="/article/17" @click="$emit('getTopSliderTop')">
                       <fai :icon="['fal', 'file-invoice' ]" style="font-size:20px;"></fai>
                      <span> Agenturbuchung</span>
                    </el-menu-item>
                  </el-menu>





          </div>
          <div class="us-footer-content-right">
            <div class="us-sozial-media-footer">
             <a target="new" href="https://www.facebook.com/LWW-Bustouristik-GmbH-174152742631691" style="color:rgba(0, 0, 0, 0.5);"><fai :icon="['fab', 'facebook-square' ]"></fai></a>
              <a target="new" href="https://goo.gl/maps/TBsKk23xdVAKZr4J8" style="color:rgba(0, 0, 0, 0.5);"><fai :icon="['fab', 'google-plus-square' ]"></fai></a>
              <a target="new" href="https://instagram.com/lwwbustouristik/" style="color:rgba(0, 0, 0, 0.5);"><fai :icon="['fab', 'instagram' ]"></fai></a>
            </div>

          </div>
          
          
          
          
          

        </div>


  </div>
</template>

<script>
  export default {
    
    components: {
      
    },
    methods: {      
      // /article/5
      goTo(link){

         this.$router.push({path: link })
      },

    }
  }
</script>


<style>
    #us-footer .el-menu {
      background-color:rgb(92, 92, 92) !important;
    }

    #us-footer{      
      width:auto;      
      padding-top:20px;  
      padding-bottom:30px;  
      background-color:rgb(92, 92, 92);
      color:#FFF;
      padding-left:15%;
      padding-right:15%;
    }    

    @media (max-width: 900px)  {    
      #us-footer{
        padding-left:4%;
        padding-right:4%;        
      } 
    }  
    @media (max-width: 750px)  { }  

    .us-footer-content {
      width:100%;      
      background-color:rgb(92, 92, 92); 
      display: flex;
      flex-direction:row;
      flex-flow: wrap;
      justify-content: flext-start; 
    }
    .us-footer-content-left{
      width:40%;
      min-width:300px;
      border-right:1px solid #FFF;    
    }
    .us-footer-content-center{
      width:calc(30% -2px );
      min-width:300px;
      
    }
    .us-footer-content-center .el-menu-item {
      color:#c4c4c4 !important; 
      background-color:rgb(92, 92, 92)!important; 
    }
    .us-footer-content-center .el-menu-item:hover {
      color:#ececec !important; 
      background-color:rgb(92, 92, 92)!important; 
    }

    .us-footer-content-center span {
      padding-left:10px;

    }

    .us-footer-content-right {
      width:calc(30% -2px );
      min-width:300px; 
      float:right !important;   
    }




    .us-footer-address {      
      color:rgba(255, 255, 255, 0.5);
      padding-bottom:10px;  
      font-size:13px;
      line-height: 140%;
    }
    .us-sozial-media-footer {
      
      font-size:90px;
      color: rgba(0, 0, 0, 0.5);
      display: flex;
      flex-direction:row;
      flex-flow: wrap;
      align-self: flex-end;
      align-items: flex-end;
      justify-content: flex-end;
    }
    .us-sozial-media-footer svg{  
       padding-left:0.5vw;
       transition: all 1s;
    } 
    .us-sozial-media-footer svg:hover{
      color: rgba(255, 255, 255, 0.5);
       
    } 
    /* .us-sozial-media-footer {
      float:right;     
      font-size:90px;
      color: rgba(0, 0, 0, 0.5);
     
    }

    

    

    .us-footer-address span{
      line-height:140%;      
    }     */
</style>


